import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBooleanGroupExclude: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBooleanGroupExclude"><Path d="M8.5 2.5H21.5V15.5H8.5V2.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M2.5 8.5H15.5V21.5H2.5V8.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBooleanGroupExclude;
